import { User } from '@/common/types/user';
import api from '@/db/apiClient';
import {
  User as AuthUser,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth';
import {
  closeProfileGate,
  openProfileGate,
  rejectProfileGate,
} from './profileReadyGate';

/**
 * Redirects the user to the Google sign in page and handles the sign in or sign up process.
 * @returns The user profile object.
 */
export async function handleSSOSignInOrSignUp() {
  openProfileGate();
  try {
    const provider = new GoogleAuthProvider();
    const { user: ssoUser } = await signInWithPopup(
      api.asEducator.auth,
      provider,
    );

    const userProfile = await api.asEducator.getUserProfile(ssoUser.uid);
    if (!userProfile) {
      await handleCreateUserProfile(ssoUser);
    }
    closeProfileGate();
  } catch (error) {
    rejectProfileGate(error);
    throw error;
  }
}

/**
 * Creates a user profile in the database.
 * @param authUser - The user object from Firebase Auth.
 * @returns The created user profile object.
 */
export async function handleCreateUserProfile(
  authUser: AuthUser,
  firstName?: string,
  lastName?: string,
) {
  const { uid, displayName, email } = authUser;
  const name =
    firstName && lastName ? `${firstName} ${lastName}` : displayName || '';
  console.log('Creating user profile for', name || email);

  try {
    // Create user object
    const now = Date.now();
    const newUser: User = {
      uid: uid,
      name,
      firstName: firstName || '',
      lastName: lastName || '',
      email: email || '',
      onboardingCompleted: false,
      onboardingInfo: {},
      organisationIds: [],
      createdAt: now,
      updatedAt: now,
    };
    await api.asEducator.createUserProfile(newUser);

    return newUser;
  } catch (error) {
    console.error('Error creating user profile:', error);
    throw new Error('Error creating user profile');
  }
}
